import {ISvgIconProps, SvgIcon} from "../../../basic-ui-components/icon/svg-icon/svg.icon";
import * as React from "react";
export interface IFilterIconProps extends ISvgIconProps{
}

export class FilterIcon extends React.Component<IFilterIconProps, {}> {

    render() {
        return (
            <SvgIcon {...this.props} viewBox="0 0 16 16" >
                <g fill="none">
                    <path d="M6.88958 6.89759L6.88851 6.89643L1.68086 1.24491H14.3196L9.11182 6.89811L9.1118 6.89809L9.10749 6.90283C8.78175 7.261 8.59528 7.73123 8.59528 8.22353V12.5066C8.59009 12.5133 8.58421 12.5209 8.57754 12.5293C8.54655 12.5685 8.51282 12.6089 8.46536 12.6657C8.45318 12.6803 8.44009 12.6959 8.42592 12.7129L7.40513 13.8832V8.22193C7.40513 7.7337 7.22289 7.26046 6.88958 6.89759Z" stroke="currentColor" strokeWidth="2"/>
                </g>
            </SvgIcon>
        )
    }
}